import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { DateService } from '../../shared/services/date.service';

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {

  dashboardData: any;
  disputesData: any;
  activeTab: 'transactions' | 'disputes' | 'risk' | 'ops' = 'transactions';
  selectedFromDate: any;
  selectedToDate: any;

  barChartSettings = {
    showXAxis: true,
    showYAxis: true,
    gradient: true,
    showLegend: false,
    showXAxisLabel: true,
    xAxisLabel: 'Country',
    showYAxisLabel: true,
    yAxisLabel: 'Amount',
    data: []
  };

  transactionsPieChart = {
    data: []
  };

  disputesPieChartSettings = {
    doughnut: true,
    gradient: true,
    showLabels: true,
    legend: false
  }

  colorScheme: Color = {
    name: "custom",
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      "#0d30da", "#ff7043", "#00bcd4", "#5e35b1", "#66bb6a"
    ],
  };

  disputesChartData = [
    { "name": "Open", "value": 0 },
    { "name": "In-Progress", "value": 0 },
    { "name": "Resolved", "value": 0 },
    { "name": "Rejected", "value": 0 },
    { "name": "Refunded", "value": 0 }
  ];
  disputesLineChartData = [
    {
      "name": "Total",
      "series": []
    },
    {
      "name": "Open",
      "series": []
    },
    {
      "name": "In Progress",
      "series": []
    },
    {
      "name": "Resolved",
      "series": []
    },
    {
      "name": "Rejected",
      "series": []
    },
    {
      "name": "Refunded",
      "series": []
    }
  ]

  isTransactions = true;

  constructor(private _api: ApiService, private _dateService: DateService) { }

  ngOnInit() {
    const vm = this;
    vm.getDashboardData();
    vm.getDashboardChartData();
    vm.getDisputes();
  }

  onToggle() {
    this.isTransactions = !this.isTransactions;
  }

  getDashboardData() {
    const vm = this;
    const reqObj = {};
    
    let apiUrl = '/admin/dashboard';
    if (vm.selectedFromDate && vm.selectedToDate) {
      const fromTimestamp = vm._dateService.dateToTimestamp(vm.selectedFromDate);
      const toTimestamp = vm._dateService.dateToTimestamp(vm.selectedToDate);
      if (!isNaN(fromTimestamp) && !isNaN(toTimestamp) && fromTimestamp > 0 && toTimestamp > 0) {
        apiUrl += `?createdAtdatePickerRange=${fromTimestamp},${toTimestamp}`;
      }
    }
    
    vm._api.postData(apiUrl, reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        vm.dashboardData = res.data;
      }
    });
  }

  isActive(tab: 'transactions' | 'disputes' | 'risk' | 'ops') {
    const vm = this;
    return vm.activeTab === tab;
  }

  setActiveTab(tab: 'transactions' | 'disputes' | 'risk' | 'ops') {
    const vm = this;
    vm.activeTab = tab;
    if (tab === 'transactions') {
      vm.getDashboardData();
      vm.getDashboardChartData();
    } else if (tab === 'disputes') {
      vm.getDisputes();
    }
  }


  getDashboardChartData() {
    const vm = this;
    const reqObj = {};
    
    let apiUrl = '/admin/dashboard-graph';
    if (vm.selectedFromDate && vm.selectedToDate) {
      const fromTimestamp = vm._dateService.dateToTimestamp(vm.selectedFromDate);
      const toTimestamp = vm._dateService.dateToTimestamp(vm.selectedToDate);
      if (!isNaN(fromTimestamp) && !isNaN(toTimestamp) && fromTimestamp > 0 && toTimestamp > 0) {
        apiUrl += `?createdAtdatePickerRange=${fromTimestamp},${toTimestamp}`;
      }
    }
    
    vm._api.postData(apiUrl, reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        vm.barChartSettings.data = res.data.spentSum;
        vm.transactionsPieChart.data = res.data.transactionsCount
      }
    });
  }

  getDisputes() {
    const vm = this;
    const reqObj = {};
    
    let apiUrl = '/admin/dashboard/disputes';
    if (vm.selectedFromDate && vm.selectedToDate) {
      const fromTimestamp = vm._dateService.dateToTimestamp(vm.selectedFromDate);
      const toTimestamp = vm._dateService.dateToTimestamp(vm.selectedToDate);
      if (!isNaN(fromTimestamp) && !isNaN(toTimestamp) && fromTimestamp > 0 && toTimestamp > 0) {
        apiUrl += `?createdAtdatePickerRange=${fromTimestamp},${toTimestamp}`;
      }
    }
    
    vm._api.postData(apiUrl, reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        vm.disputesData = res.data;
        vm.disputesChartData[0].value = vm.disputesData.open;
        vm.disputesChartData[1].value = vm.disputesData.inProgress;
        vm.disputesChartData[2].value = vm.disputesData.resolved;
        vm.disputesChartData[3].value = vm.disputesData.rejected;
        vm.disputesChartData[4].value = vm.disputesData.refunded;

        vm.disputesLineChartData[0].series = res.data.countryCount;
        vm.disputesLineChartData[1].series = res.data.countryOpenCount;
        vm.disputesLineChartData[2].series = res.data.countryInProgressCount;
        vm.disputesLineChartData[3].series = res.data.countryResolvedCount;
        vm.disputesLineChartData[4].series = res.data.countryRejectedCount;
        vm.disputesLineChartData[5].series = res.data.countryRefundedCount;


      }
    });
  }

  onDisputeSelect(event: any) {

  }

  onDateSelected(result: { fromDate: any, toDate: any }) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    
    vm.getDashboardData();
    vm.getDashboardChartData();
    if (vm.activeTab === 'disputes') {
      vm.getDisputes();
    }
  }

}
